import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=22d2091f&"
import script from "./ContentBlock.vue?vue&type=script&lang=ts&"
export * from "./ContentBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ContentBlock.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports